import List from "./List";
import Query from "./Query";
import Nav from "./Nav";

export default {
    list: List,
    query: Query,
    nav: Nav,
};
